import { connect } from 'react-redux';
import {
  currentUser,
  accessToken as getAccessToken,
} from '../../../../../core/selectors/user';
import * as endpoints from '../../../../constants/endpoints';
import { isInstructor } from '../../../../utils/user';
import EditorReadOnly from './EditorReadOnly';

const scraperUrl = () => ({ scraperUrl: endpoints.WEB_SCAPER() });

const mapStateToProps = (state) => {
  const user = currentUser(state);
  const spaceId = state.classRoom.current;

  return {
    accessToken: getAccessToken(state, spaceId),
    institution: state.institution.general.institution,
    isInstructor: isInstructor(user.objectId),
    scraperUrl,
    spaceId,
    spaceName: spaceId && state.data.classRooms[spaceId].name,
    user,
  };
};

export default connect(mapStateToProps)(EditorReadOnly);
